export const validation = {
  headingMaxChar: 200,
  dateLabelsMaxChar: 20
}
